import { Component, ElementRef, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxIntlTelInputModule, SearchCountryField } from 'ngx-intl-tel-input';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { User, Tenant } from '../../../models/users.model';
import { provideNativeDateAdapter } from '@angular/material/core';
import { NgIf } from '@angular/common';
import { LoadingService } from '../../../services/loading.service';
import { Offcanvas } from 'bootstrap';

@Component({
  selector: 'app-tenant-add',
  imports: [NgIf, ReactiveFormsModule, NgbModule, NgxIntlTelInputModule, MatRadioModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatSelectModule],
  templateUrl: './tenant-add.component.html',
  styleUrl: './tenant-add.component.css',
  providers: [provideNativeDateAdapter()]
})
export class TenantAddComponent {
  tenantadd_edit :  boolean = false;
  userForm! : FormGroup;
  today : Date = new Date();
  SearchCountryField = SearchCountryField;
  loadingService = inject(LoadingService);
  @Output() addTenantEvent = new EventEmitter();
  @ViewChild('addTenantButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  constructor(private fb: FormBuilder) {
    this.userForm = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      email : ['', [Validators.required,  Validators.email]],
      phone : ['', [Validators.required]],
      alternate_email : [''],
      alternate_phone : [''],
      gender : [''],
      dob : [''],
      driving_license : [''],
      marital_status : [''],
      aadhar : [''],
      pan : [''],
      allow_login : [false]
    });
  }

   ngAfterViewInit() {
      setTimeout(() => {
        const offcanvasElement = this.offcanvas?.nativeElement;
        if (offcanvasElement) {
          this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
            backdrop: 'static', 
            keyboard: false,
          });        
        }
      });
    }
  
    addPropertyEvent(){    
      this.toggleSearch();   
      if (this.offcanvasInstance) {
        this.offcanvasInstance.show();
      }
    }
  
    propertyClose(){
      this.toggleSearch();
      if (this.offcanvasInstance) {      
        this.offcanvasInstance.hide();
      }
    }

  toggleSearch() {
    this.tenantadd_edit = !this.tenantadd_edit;
  }

  searchClose(){    
    this.toggleSearch();
  }

  disableFutureDates = (date: Date | null): boolean => {
    return date ? date <= this.today : false;
  }

  onSubmit() {
    //this.toggleSearch();
    this.addTenantEvent.emit(this.userForm);
  }

  resetForm(){
    this.userForm.reset();
  }
}
